import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/logEntryActions';
import * as events from '../constants/eventActions';
import * as entityUtils from '../utils/entityUtils';
import Time from "../utils/time";


export function commandCreate(command) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .post(env.tashi + '/logEntries/commander')
      .send({
        command: command
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.createCommandLogEntry({ status: "failure", data: err }));
          return;
        }

        let data = JSON.parse(res.text);

        if (res.ok) {
          if (data) {
            dispatch(actions.createCommandLogEntry({ status: "success", data: data }));
          } else {
            dispatch(actions.createCommandLogEntry({ status: "success", data: [] }));
          }
        } else {
          dispatch(actions.createCommandLogEntry({ status: "failure", data: res.status }));
        }
      });
  };
}

export function create(logEntry) {
  return dispatch => {
    /*dispatch(actions.setLoadingFlagForLogEntryState());*/

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }

    request
      .post(env.tashi + '/logEntries/new')
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          if (err.status === 500) {
            dispatch(actions.createLogEntry({ status: "failure", data: err }));
            dispatch(events.pushErrorEvent({ data: err.response.body }));
          } else {
            dispatch(actions.createLogEntry({ status: "failure", data: err }));
            dispatch(events.pushErrorEvent({ data: "create logentry" }));
          }
          
          return;
        }
        
        logEntry.id = entityUtils.getIDFromLink(res.header.location); //we get the newly created logEntry ID

        if (res.ok) {
          dispatch(actions.createLogEntry({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "create logentry" }));
        } else {
          dispatch(actions.createLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "create logentry" }));
        }
      });
  };
}

export function deleteEntry(logEntryID) {
  return dispatch => {
    /*dispatch(actions.setLoadingFlagForLogEntryState());*/

    request
      .post(env.tashi + '/logEntries/' + logEntryID + '/delete')
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          dispatch(actions.deleteLogEntry({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "delete logentry" }));
          return;
        }

        if (res.ok) {
          dispatch(actions.deleteLogEntry({ status: "success", data: logEntryID }));
          dispatch(events.pushSuccessEvent({ data: "delete logentry" }));
        } else {
          dispatch(actions.deleteLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "delete logentry" }));
        }
      });
  };
}

export function loadByTask(task) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findByTask')
      .query({
        task: task
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesByTask({ status: "failure", data: err }));
          return;
        }

        let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : null;

        if (data) {
          dispatch(actions.loadLogEntriesByTask({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesByTask({ status: "success", data: [] }));
        }
      });
  };
}

export function loadByTimesheet(timesheet) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findLogEntries')
      .query({
        timesheet: timesheet
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesByTimesheet({ status: "failure", data: err }));
          return;
        }

        let data =  JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : [];

        if (data) {
          dispatch(actions.loadLogEntriesByTimesheet({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesByTimesheet({ status: "success", data: [] }));
        }
      });
  };
}

export function loadByTimesheetTasks(timesheet) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/findByTimesheet')
      .query({
        timesheet: timesheet
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesByTimesheetTasks({ status: "failure", data: err }));
          return;
        }

        let data =  JSON.parse(res.text);

        if (data) {
          dispatch(actions.loadLogEntriesByTimesheetTasks({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesByTimesheetTasks({ status: "success", data: [] }));
        }
      });
  };
}

export function loadOnDate(date) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findByDate')
      .query({
        date: date.format("YYYY-MM-DD")
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesOnDate({ status: "failure", data: err }));
          return;
        }

        let data =  JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : null;

        if (data) {
          dispatch(actions.loadLogEntriesOnDate({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesOnDate({ status: "success", data: [] }));
        }
      });
  };
}

export function loadOnDateForUser(date, user) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findByDateAndUser')
      .query({
        date: date.format("YYYY-MM-DD")
        , user: user.id
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesOnDateForUser({ status: "failure", data: err }));
          return;
        }

        let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : null;

        if (data) {
          dispatch(actions.loadLogEntriesOnDateForUser({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesOnDateForUser({ status: "success", data: [] }));
        }
      });
  };
}

export function loadOnWeek(date) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findByYearAndWeek')
      .query({
        year: date.format("YYYY"),
        week: Time.getWeek(date)
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogentriesOnWeek({ status: "failure", data: err }));
          return;
        }

        let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : null;

        if (data) {
          dispatch(actions.loadLogentriesOnWeek({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogentriesOnWeek({ status: "success", data: [] }));
        }
      });
  };
}

export function loadOnWeekForUser(date, userID) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .get(env.tashi + '/logEntries/search/findByYearAndWeekForUser')
      .query({
        year: date.format("YYYY")
        , week: Time.getWeek(date)
        , user: userID
      })
      .accept('application/json')
      .withCredentials()
      .end((err, res) => {
        if (err) {
          dispatch(actions.loadLogEntriesOnWeekForUser({ status: "failure", data: err }));
          return;
        }

        let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.logEntries : null;

        if (data) {
          dispatch(actions.loadLogEntriesOnWeekForUser({ status: "success", data: data }));
        } else {
          dispatch(actions.loadLogEntriesOnWeekForUser({ status: "success", data: [] }));
        }
      });
  };
}

export function pmoEditStatus(logEntryID, logEntryStatus) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .post(env.tashi + '/logEntries/' + logEntryID + '/setStatus')
      .query({
        status: logEntryStatus
      })
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          dispatch(actions.pmoEditLogEntryStatus({ status: "failure", data: err }));
          return;
        }

        if (res.ok) {
          let data = {logEntryID, status: logEntryStatus};
          dispatch(actions.pmoEditLogEntryStatus({ status: "success", data: data }));
        } else {
          dispatch(actions.pmoEditLogEntryStatus({ status: "failure", data: res.status }));
        }
      });
  };
}

export function pmoCreate(logEntry) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }

    request
      .post(env.tashi + '/logEntries/pmo_new')
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          dispatch(actions.pmoCreateLogEntry({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "pmo create logentry" }));
          return;
        }

        logEntry.id = entityUtils.getIDFromLink(res.header.location); //we get the newly created logEntry ID

        if (res.ok) {
          dispatch(actions.pmoCreateLogEntry({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "pmo create logentry" }));
        } else {
          dispatch(actions.pmoCreateLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "pmo create logentry" }));
        }
      });
  };
}

export function pmoDeleteEntry(logEntryID) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .post(env.tashi + '/logEntries/' + logEntryID + '/pmo_delete')
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          dispatch(actions.pmoDeleteLogEntry({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "pmo delete logentry" }));
          return;
        }

        if (res.ok) {
          dispatch(actions.pmoDeleteLogEntry({ status: "success", data: logEntryID }));
          dispatch(events.pushSuccessEvent({ data: "pmo delete logentry" }));
        } else {
          dispatch(actions.pmoDeleteLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "pmo delete logentry" }));
        }
      });
  };
}

export function pmoUpdate(logEntry) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }
    pureLogEntry.user = {};
    pureLogEntry.user.id = pureLogEntry.userID;

    request
      .put(env.tashi + '/logEntries/' + logEntry.id + "/pmo_edit")
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          dispatch(actions.pmoUpdateLogEntry({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "pmo update logentry" }));
          return;
        }

        if (res.ok) {
          dispatch(actions.pmoUpdateLogEntry({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "pmo update logentry" }));
        } else {
          dispatch(actions.pmoUpdateLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "pmo update logentry" }));
        }
      });
  };
}

export function pmoUpdateWithTask(logEntry) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }

    request
      .put(env.tashi + '/logEntries/' + logEntry.id + "/pmo_editWithTask")
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          dispatch(actions.pmoUpdateLogEntryTask({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "pmo update logentry with task" }));
          return;
        }

        if (res.ok) {
          logEntry.oldId = logEntry.id;  //we need the old ID to delete it off front-end
          logEntry.id = entityUtils.getIDFromLink(res.header.location); //we get the newly created logEntry ID

          dispatch(actions.pmoUpdateLogEntryTask({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "pmo update logentry with task" }));
        } else {
          dispatch(actions.pmoUpdateLogEntryTask({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "pmo update logentry with task" }));
        }
      });
  };
}

export function stopTimer(logEntry) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    request
      .post(env.tashi + "/logEntries/" + logEntry.id + "/stop")
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          dispatch(actions.stopTimerLogEntry({ status: "failure", data: err }));
          return;
        }

        if (res.ok) {
          logEntry.status = "DRAFT";
          dispatch(actions.stopTimerLogEntry({ status: "success", data: logEntry }));
        } else {
          dispatch(actions.stopTimerLogEntry({ status: "failure", data: res.status }));
        }
      });
  };
}

export function update(logEntry) {
  return dispatch => {
    /*dispatch(actions.setLoadingFlagForLogEntryState());*/

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    if (!logEntry.task || !logEntry.task.id) {
      if (logEntry.taskID) {
        logEntry.task = {};
        logEntry.task.id = logEntry.taskID;
      } else if (logEntry._links) {
        logEntry.task = {};
        logEntry.task.id = entityUtils.getIDFromLink(logEntry._links.dl_task.href);
      }
    }

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }

    request
      .put(env.tashi + '/logEntries/' + logEntry.id + "/edit")
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          dispatch(actions.updateLogEntry({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "update log entry" }));
          return;
        }

        if (res.ok) {
          dispatch(actions.updateLogEntry({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "update log entry" }));
        } else {
          dispatch(actions.updateLogEntry({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "update log entry" }));
        }
      });
  };
}

export function updateWithTask(logEntry) {
  return dispatch => {
    dispatch(actions.setLoadingFlagForLogEntryState());

    // construct a pure logEntry object which doesn't have unnecessary fields usually used for optimistical updates
    let pureLogEntry = {};
    let blacklistedKeys = ["lastModifiedByUser", "lastModifiedAt"];

    for (let key in logEntry) {
      if (blacklistedKeys.indexOf(key) === -1) {
        pureLogEntry[key] = logEntry[key];
      }
    }

    request
      .put(env.tashi + '/logEntries/' + logEntry.id + "/editWithTask")
      .withCredentials()
      .accept('application/json')
      .send(pureLogEntry)
      .end((err, res) => {
        if (err) {
          dispatch(actions.updateLogEntryTask({ status: "failure", data: err }));
          dispatch(events.pushErrorEvent({ data: "update log entry with task" }));
          return;
        }

        if (res.ok) {
          logEntry.oldId = logEntry.id;  //we need the old ID to delete it off front-end
          logEntry.id = entityUtils.getIDFromLink(res.header.location); //we get the newly created logEntry ID

          dispatch(actions.updateLogEntryTask({ status: "success", data: logEntry }));
          dispatch(events.pushSuccessEvent({ data: "update log entry with task" }));
        } else {
          dispatch(actions.updateLogEntryTask({ status: "failure", data: res.status }));
          dispatch(events.pushErrorEvent({ data: "update log entry with task" }));
        }
      });
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/logEntryActionCreators.js
 **/